import { render } from "./Deck.vue?vue&type=template&id=1a1ed742"
import script from "./Deck.vue?vue&type=script&lang=js"
export * from "./Deck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__